// extracted by mini-css-extract-plugin
export default {"subtitle":"MembershipValidationCode_subtitle__w7x78"};